import store from '@/store'

const SDK_URLS = {
  domesticProd: 'https://certificates.meituan.com/cert/latestsdk',
  domesticTest: 'https://pki.inf.test.sankuai.com/cert/latestsdk',
  overseasProd: 'https://certificates.mykeeta.com/cert/latestsdk'
}

function isProduction(): boolean {
  const host = window.location.host
  return host === 'wenshu.sankuai.com' || host === 'wenshu.sec.st.sankuai.com' || host === 'wenshu.mykeeta.com'
}

function getSdkUrl(): string {
  const hostname = window.location.hostname
  // 境外：始终用境外 Prod
  if (hostname.endsWith('.mykeeta.com')) {
    return SDK_URLS.overseasProd
  }
  // 国内：生产环境用 Prod，其他环境（test/开发）也接入 Prod SDK
  // 文档建议：若线下环境的用户也存在升级推升需求，建议直接接入 Prod SDK
  return SDK_URLS.domesticProd
}

function loadScript(url: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = url
    script.defer = true
    script.onload = () => resolve()
    script.onerror = (e) => reject(e)
    document.head.appendChild(script)
  })
}

export async function initCertSdk(): Promise<void> {
  try {
    const sdkUrl = getSdkUrl()
    if (!sdkUrl) {
      return
    }
    const userinfo = (store.state as any).user.userinfo
    const userId = userinfo ? userinfo.mis : ''
    if (!userId) {
      console.warn('[certSdk] userId (mis) is empty, skip init')
      return
    }
    await loadScript(sdkUrl)
    const Bfe = (window as any).BfePkiCertManager
    if (!Bfe || typeof Bfe.init !== 'function') {
      console.warn('[certSdk] BfePkiCertManager not available')
      return
    }
    await Bfe.init({
      bizName: window.location.hostname,
      userId: userId,
      autoPopup: true
    })
  } catch (e) {
    console.error('[certSdk] init failed', e)
  }
}
